module.exports = __webpack_public_path__ + "media/images/captive_portal/Color-Eight-041475bec4650f0871cd10c7d7ac4a92.png";